(function () {
    'use strict';
    $(document).ready(function () {
        const $header = $('header');
        const $menuInline = $('.menu-container');
        let lastWindowWidth = $(window).width();

        // Menu toggle
	    $('.menu-toggle').on('click', function () {
		    $menuInline.fadeToggle(300);
		    $menuInline.toggleClass('open');
		    $(this).toggleClass('open');
		    $header.toggleClass('open');
		    closeSubmenus();
	    });


	    $('ul.header-main-menu li.menu-item-has-children > .menu-item-trigger').on('click', function (e) {
		    e.preventDefault();
		    const $this = $(this);
		    const $li = $(this).parent();
		    const $siblingList = $(this).siblings('.submenu-wrapper');
		    const submenuLevel = $this.data('depth');

		    //if (`${submenuLevel}` === '2' && !isMobileMedia.matches) return;

		    if ($this.hasClass('active')) {
			    $siblingList.stop().slideUp(300);
			    $li.removeClass('open');
			    $this.removeClass('active');
			    $this.attr('aria-expanded', 'false');
		    } else {
			    closeSubmenus(submenuLevel);
			    $siblingList.stop().slideToggle(300);
			    $li.toggleClass('open');
			    $this.toggleClass('active');
			    $this.attr(
				    'aria-expanded',
				    $this.attr('aria-expanded') === 'true' ? 'false' : 'true',
			    );
		    }
	    });

	    function closeSubmenus(dataLevel = 1) {
		    $(`ul[data-level="${dataLevel}"] li.menu-item-has-children > .menu-item-trigger.active`).each(function () {
			    $(this).siblings('.submenu-wrapper').stop().slideToggle(300, function () {
				    $(this).css('display', '');
			    });
			    $(this).removeClass('active');
			    $(this).attr('aria-expanded', 'false');
			    $(this).parent().removeClass('open');
		    });
	    }


    });
}(jQuery));
